import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Buefy from 'buefy'

import axios from 'axios'
import VueAxios from 'vue-axios'

import SharkLoader from '@/components/SharkLoader.vue'

Vue.use(Buefy, {
  defaultIconPack: 'fas'
});

Vue.use(VueAxios, axios);

// We'll keep the shark loader here so we can use it everywhere
Vue.component('shark-loader', SharkLoader);

Vue.config.productionTip = process.env.NODE_ENV === 'production';
Vue.apiRoot = Vue.config.productionTip ? "https://coordinator.thebeachatsharkeys.com/api" : "http://localhost:7999/api";
Vue.prototype.$configuration = JSON.stringify(Vue.config);
Vue.prototype.$processEnv = JSON.stringify(process.env);
Vue.prototype.$apiRoot = Vue.apiRoot;

// Not trying to have a /leagues root now
/*
router.beforeEach((to, from, next) => {
  if (to.path.startsWith("/") && !to.path.startsWith("/leagues")) {
    let path = "/leagues" + to.path;
    // If we allow every route on our path to be similar like this we should be fine :)
    // let extended = Object.assign({}, to, {path});
    next(path);
  } else {
    next();
  }
});
*/

/* Global filter(s) */
Vue.filter('capitalize', function(name) {
  if (!name) return name;
  else if (typeof name != "string" || name.length == 0) return name;
  return name.split(/\s+/).filter(name => Boolean(name)).map(name => name[0].toUpperCase() + name.slice(1).toLowerCase()).join(' ');
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')